import AbilityScoreManagerPointBuy from './AbilityScoreManagerPointBuy';

export default AbilityScoreManagerPointBuy;
export { AbilityScoreManagerPointBuy };
